<script>
	import Footer from '$lib/components/footer/Footer.svelte';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { currentLanguage, supportedLanguages } from '$lib/i18n.js';
	import NavBar from '$lib/components/Navbar.svelte';
	import '../../../app.css';

	export let data;

	onMount(() => {
		currentLanguage.set(data.lang);
	});
</script>

<div class="app">
	<NavBar
		foregroundColor="var(--on-surface)"
		backgroundColor="var(--surface)"
		logoAndTextsColor="var(--surface)"
		logoInverted={false}
	/>
	
	<main>
		<slot />
	</main>
</div>

<style>
	.app {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
</style>